import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var IntroPage = React.lazy(function () { return import('../pages/authentication/intro/intro.page'); });
var introRedirectPages = [
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.AnonymousCouponRedeemUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
    {
        userRole: UserRole.CompleteUser,
        page: AppRoutes.Plan,
    },
];
var authenticationRoutes = [
    {
        path: AppRoutes.Intro,
        element: (_jsx(RouteAuthorizer, { userRoles: [
                UserRole.Anonymous,
                UserRole.NoCountryUser,
                UserRole.AnonymousCouponRedeemUser,
            ], redirectPages: introRedirectPages, children: _jsx(IntroPage, {}) })),
    },
];
export default authenticationRoutes;
